import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import {
  ApiBuilder,
  AppConfigService,
  CheckInStaticAem,
  handleError,
  HttpRequestMethods,
  IDP_APPS
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { Observable, of } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { CommonConstants, HEADER_FEATURES } from '../models/enums/header.enums';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  errorHandler = handleError.bind(this);
  timeout: number = CommonConstants.TIMEOUT;
  checkInStaticContentJson$!: Observable<CheckInStaticAem | null>;
  checkInStaticContentError$!: Observable<string>;
  constructor(private appConfig: AppConfigService, private http: HttpClient) {}

  getCheckInStaticContent$(): Observable<CheckInStaticAem | null> {
    if (this.checkInStaticContentJson$) {
      return this.checkInStaticContentJson$;
    } else {
      this.checkInStaticContentJson$ = this.getCheckInStaticContent().pipe(
        catchError(() => {
          this.checkInStaticContentError$ = of(
            'Error loading check-in static content:'
          );
          return of(null); // Return empty fallback
        }),
        shareReplay(1)
      );
      return this.checkInStaticContentJson$;
    }
  }

  getCheckInStaticContent = (): Observable<CheckInStaticAem> => {
    return new ApiBuilder<undefined, CheckInStaticAem>(
      this.http,
      this.appConfig
    )
      .app(IDP_APPS.HEADER)
      .endpointKey('CHECK_IN_STATIC_URL')
      .method(HttpRequestMethods['GET'])
      .timeOut(CommonConstants.TIMEOUT)
      .errorHandler(this.errorHandler)
      .library(HEADER_FEATURES.CHECK_IN)
      .create();
  };
}
